import { render } from "./TreasurePlate.vue?vue&type=template&id=553e5bb9&scoped=true"
import script from "./TreasurePlate.vue?vue&type=script&lang=js"
export * from "./TreasurePlate.vue?vue&type=script&lang=js"

import "./TreasurePlate.vue?vue&type=style&index=0&id=553e5bb9&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-553e5bb9"]])

export default __exports__